export default __webpack_public_path__ + "static/media/kenp4chi.c1f55a3d.png";